import { render, staticRenderFns } from "./SummaryCart.vue?vue&type=template&id=3b6a2865&scoped=true"
import script from "./SummaryCart.vue?vue&type=script&lang=js"
export * from "./SummaryCart.vue?vue&type=script&lang=js"
import style0 from "./SummaryCart.vue?vue&type=style&index=0&id=3b6a2865&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6a2865",
  null
  
)

export default component.exports